// TMessageBox.js
import { MessageBox } from 'element-ui';

class TMessageBox {
	// 确认对话框
	static confirm(message, title = '提示', options = {}) {
		return MessageBox.confirm(message, title, {
			confirmButtonText: options.confirmButtonText ? options.confirmButtonText : '确定',
			cancelButtonText: '取消',
			type: 'warning',
			...options
		});
	}

	// alert 对话框
	static alert(message, title = '提示', options = {}) {
		return MessageBox.alert(message, title, {
			confirmButtonText: '确定',
			...options
		});
	}

	// prompt 对话框
	static prompt(message, title = '提示', options = {}) {
		return MessageBox.prompt(message, title, {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			...options
		});
	}

	// 自定义对话框
	static msgbox(options) {
		return MessageBox(options);
	}

	// 删除确认（常用场景封装）
	static deleteConfirm(message = '此操作将永久删除该数据, 是否继续?') {
		return this.confirm(message, '删除确认', {
			type: 'error'
		});
	}

	// 成功提示
	static success(message, title = '成功') {
		return this.alert(message, title, {
			type: 'success'
		});
	}

	// 错误提示
	static error(message, title = '错误') {
		return this.alert(message, title, {
			type: 'error'
		});
	}

	// 警告提示
	static warning(message, title = '警告') {
		return this.alert(message, title, {
			type: 'warning'
		});
	}
}

export default TMessageBox;

// 使用说明
// 在组件中使用
// import TMessageBox from '@/utils/TMessageBox'
//
// // 确认对话框
// TMessageBox.confirm('确定要删除吗？')
//     .then(() => {
//         // 用户点击确定
//         console.log('用户确认删除')
//     })
//     .catch(() => {
//         // 用户点击取消
//         console.log('用户取消操作')
//     })
//
// // 删除确认（预设样式）
// TMessageBox.deleteConfirm()
//     .then(() => {
//         // 执行删除逻辑
//     })
//
// // Alert 提示
// TMessageBox.alert('操作成功', '提示', {
//     type: 'success'
// })
//
// // Prompt 输入框
// TMessageBox.prompt('请输入用户名', '提示')
//     .then(({ value }) => {
//         console.log('用户输入:', value)
//     })
//     .catch(() => {
//         console.log('用户取消输入')
//     })
